import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconYen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconYen"><Path d="M8.5 8L12 12M12 12L15.5 8M12 12V12.5M12 12.5V14.5M12 12.5H9.5M12 12.5H14.5M12 14.5V17.5M12 14.5H9.5M12 14.5H14.5M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconYen;
